import { chooseReducer } from '@/utils/draftHelper';
import initialState from './state';
import updateMetricsState from './metrics';

export default (state = initialState, action) => chooseReducer(state, action, updateMetricsState);
